import { __rest, __assign } from 'tslib';
import React from 'react';
import { DragIndicatorIcon } from '@panwds/icons';
import { classNames, Tooltip } from '@panwds/react-ui';

function DragHandle(_a) {
    var isHeld = _a.isHeld, _b = _a.disabled, disabled = _b === void 0 ? false : _b, label = _a.label, addClassName = _a.addClassName, _c = _a.iconSize, iconSize = _c === void 0 ? "xs" : _c, rest = __rest(_a, ["isHeld", "disabled", "label", "addClassName", "iconSize"]);
    var button = (React.createElement("button", __assign({ "aria-label": label, className: classNames("tw-border-none tw-bg-transparent", isHeld && "tw-text-default", disabled
            ? "hover:tw-text-default tw-cursor-not-allowed"
            : "tw-cursor-move focus:outline-none focus-visible:ring", addClassName) }, rest),
        React.createElement(DragIndicatorIcon, { className: "tw-text-gray-400 dark:tw-text-dark-bg", size: iconSize })));
    if (isHeld)
        return button;
    if (disabled) {
        /* istanbul ignore next */
        if (typeof disabled === "boolean")
            return button;
        return React.createElement(Tooltip, { label: disabled }, button);
    }
    return React.createElement(Tooltip, { label: label }, button);
}

export { DragHandle };
//# sourceMappingURL=DragHandle.esm.js.map
